"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = normalizeInitials;

function normalizeInitials(initials) {
  return initials.slice(0, 2);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/Avatar/normalizeInitials.js
// module id = p8L/
// module chunks = 0